import * as Sentry from '@sentry/react'
import { rudder } from '#app/third-party/tools/rudder'
import { clearLastUsedAccount } from '#lib/account/account-persist'

/** Clean up Rudder, Sentry, local storage, etc. */
function clearUserData() {
  try {
    rudder?.reset()
    Sentry.setUser(null)

    clearLastUsedAccount()
  } catch (error) {
    Sentry.captureException(error)
  }
}

export function clearSession() {
  clearUserData()
  location.href = '/_auth/clear-session'
}

export function signOut() {
  clearUserData()
  location.href = '/_auth/signout'
}
